import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Alert from "react-s-alert";
import "react-s-alert/dist/s-alert-default.css";
import "react-s-alert/dist/s-alert-css-effects/slide.css";
import "react-s-alert/dist/s-alert-css-effects/bouncyflip.css";
import SocketContext from "./function/SocketContext";
// import { isMobile } from "react-device-detect";

import Routes from "./store/utils/Routes";
import { Provider } from "react-redux";
import store from "./store/store";
import setAuthToken from "./store/utils/setAuthToken";
import jwt_decode from "jwt-decode";
import { SET_CURRENT_USER_DECODED_TOKEN } from "./store/types";
import {
  set_current_user,
  logOutUser,
  create_and_update_restaurant,
  get_new_subscription_for_vendor,
  get_notification_count,
} from "./store/actions/authAction";
import {
  superadmin_create_and_update_restaurant,
  admin_get_new_subscription_for_vendor,
} from "./store/actions/SuperAdminActions/adminNewVendorOnboard";
import {
  get_all_category,
  get_all_subcategory,
} from "./store/actions/categoryActions";
import isEmpty from "./store/validation/is-Empty";
import { serverApi } from "./config/Keys";

import feathers from "@feathersjs/client";
import socketio from "@feathersjs/socketio-client";
import io from "socket.io-client";
import ErrorTemplate from "./ErrorBoundary";
import { setAuthenticationToken } from "./api/apiHelper";
import BrowserNotification from "./Notification";
import NotificationPopup from "./NotificationPopup";
import IdleTimer from "react-idle-timer";
import SessionPopupComponent from "./components/authentication/AdminOtpAuth/SessionPopupComponent";
import SessionExpiry from "./components/authentication/AdminOtpAuth/SessionExpiryComponent";
import OnlineSessionComponent from "./components/authentication/AdminOtpAuth/OnlineSessionComponent";
import ReloginComponent from "./components/authentication/AdminOtpAuth/ReloginComponent";
import CallingCardDraggable from "./components/reusableComponents/allPopupReusable/CallingCardDraggable";

// import authentication from "@feathersjs/client/authentication";

const host = serverApi;
let socket = io(host, { transports: ["websocket"] });

/***************************************
 *  JWT AUTHENTICATION
 ***************************************/
let data = JSON.parse(localStorage.getItem("userData"));
let adminVendorId = JSON.parse(localStorage.getItem("vendorId"));
let app = feathers();
app.configure(socketio(socket));
app.configure(
  feathers.authentication({
    storage: localStorage,
    path: "vendorauthentication",
  })
);
if (data && data.accessToken) {
  app.authentication.setAccessToken(data.accessToken);
  setAuthenticationToken(data.accessToken);
  app.authentication.reAuthenticate();
  // .then((r) => {
  //   console.log("resposr", r);
  // })
  // .catch((e) => {
  //   console.log("error", e);
  // });
} else {
  console.log("Feather Token Not Found");
}

const decoded = !isEmpty(data) && jwt_decode(data.accessToken);
let redux_state = store.getState();
if (!redux_state?.all_category || redux_state?.all_category?.length === 0)
  store.dispatch(get_all_category());

if (!redux_state?.storage?.flag) store.dispatch(get_all_subcategory());
const currentTime = Date.now() / 1000;
if (data && decoded.exp >= Math.round(currentTime)) {
  setAuthToken(data.accessToken);
  setAuthenticationToken(data.accessToken);
  const formData = {
    vendor_id: data.VendorUser._id,
  };
  store.dispatch(
    create_and_update_restaurant({
      vendor_id: data.VendorUser._id,
      strategy: "category",
      sub_category: ["5f562c9094ac7fdf47ea1d0a"],
    })
  );
  store.dispatch(get_new_subscription_for_vendor(formData));
  if (adminVendorId === null) {
    console.log("Without Token");
  } else {
    console.log("With Token");
    const formData = {
      vendor_id: data.VendorUser._id,
    };
    store.dispatch(
      superadmin_create_and_update_restaurant({
        vendor_id: adminVendorId,
        strategy: "category",
        sub_category: ["5f562c9094ac7fdf47ea1d0a"],
      })
    );
  }
  if (adminVendorId === null) {
    console.log("Without Token");
  } else {
    console.log("With Subscription Token");
    store.dispatch(
      admin_get_new_subscription_for_vendor(data.accessToken, adminVendorId)
    );
  }

  store.dispatch(set_current_user(data));
  const decoded = jwt_decode(data.accessToken);
  store.dispatch({
    type: SET_CURRENT_USER_DECODED_TOKEN,
    payload: decoded,
  });
  store.dispatch(get_notification_count(data.accessToken));
} else {
  store.dispatch(logOutUser());
  localStorage.clear();
}
/***************************************
 *  JWT AUTHENTICATION ENDS
 ***************************************/

export class App extends Component {
  constructor(props) {
    super(props);
    this.idleTimer = null;
    this.timeout = 1000 * 60 * 30;
    this.warningTime = 1000 * 60 * 5;
    this.state = {
      remaining: this.timeout,
      isIdle: false,
      lastActive: new Date(),
      elapsed: 0,
      lastEvent: "Events Emitted on Leader",
      leader: false,
      expiry: false,
      session: false,
    };
    // Bind event handlers and methods
    this.handleOnActive = this.handleOnActive.bind(this);
    this.handleOnIdle = this.handleOnIdle.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handlePause = this.handlePause.bind(this);
    this.handleResume = this.handleResume.bind(this);
  }

  componentDidMount() {
    this.setState({
      remaining: this.idleTimer.getRemainingTime(),
      lastActive: this.idleTimer.getLastActiveTime(),
      elapsed: this.idleTimer.getElapsedTime(),
      leader: this.idleTimer.isLeader(),
      isIdle: this.idleTimer.isIdle(),
    });

    setInterval(() => {
      let vendor = JSON.parse(localStorage.getItem("userData"));
      if (
        vendor?.VendorUser?._id &&
        vendor?.VendorUser?.role === "superadmin"
      ) {
        this.setState({
          remaining: this.idleTimer.getRemainingTime(),
          lastActive: this.idleTimer.getLastActiveTime(),
          elapsed: this.idleTimer.getElapsedTime(),
          leader: this.idleTimer.isLeader(),
          isIdle: this.idleTimer.isIdle(),
        });
        if (this.idleTimer.getRemainingTime() <= this.warningTime) {
          this.setState({ expiry: true });
        }
        if (this.idleTimer.getRemainingTime() <= 0) {
          this.setState({ session: true });
        }
      }
    }, 1000);
  }

  handleOnActive() {
    this.setState({ expiry: false });
    this.setState({ lastEvent: "active" });
  }

  handleOnIdle() {
    this.setState({ lastEvent: "idle" });
  }

  handleReset() {
    this.idleTimer.reset();
  }

  handlePause() {
    this.idleTimer.pause();
  }

  handleResume() {
    this.idleTimer.resume();
  }

  render() {
    return (
      <SocketContext.Provider value={app}>
        <Provider store={store}>
          <Router>
            <ErrorTemplate>
              <Switch>
                <Route component={Routes} />
              </Switch>
            </ErrorTemplate>
            {window?.location?.hostname.includes("localhost") ? null : (
              <NotificationPopup />
              )} 
            {window?.location?.hostname.includes("localhost") ? null : (
              <SessionPopupComponent open={this.state.session} /> 
            )}
            {window?.location?.hostname.includes("localhost") ? null : (
              <OnlineSessionComponent />
            )}
            <ReloginComponent />
            <SessionExpiry
              open={this.state.expiry}
              timeLeft={this.state.remaining}
            />
            <CallingCardDraggable />
          </Router>
          <span>{this.props.children}</span>
          <Alert stack={{ limit: 3 }} />
          <IdleTimer
            ref={(ref) => {
              this.idleTimer = ref;
            }}
            onActive={this.handleOnActive}
            onIdle={this.handleOnIdle}
            timeout={this.timeout}
            crossTab={{
              emitOnAllTabs: true,
            }}
          />
          {/* {!isMobile && <BrowserNotification />} */}
        </Provider>
      </SocketContext.Provider>
    );
  }
}

export default App;
